<aside class="activities-feedback"
  [ngClass]="classCss"
  [class.activities-feedback--folded]="folded"
  @fadeAndSlideIn>

  <button class="activities-feedback__toggle-button"
    (click)="toggleFeedback()">
    <mat-icon class="activities-feedback__toggle-icon"
      svgIcon="keyboard-arrow-down-rounded-full">
    </mat-icon>
  </button>

  <div class="activities-feedback__short-feedback">
    <ng-container>
      <mat-icon class="activities-feedback__short-feedback-icon"
        [svgIcon]="svgIcon">
      </mat-icon>
      @if (feedback.innerHtmlContent) {
        <p class="activities-feedback__short-feedback-text" [innerHTML]="feedback.innerHtmlContent"></p>
      }
      @if (feedback.content) {
        <p class="activities-feedback__short-feedback-text">{{feedback.content}}</p>
      }
      @if (feedback.contentWithTermInterface) {
        <p class="activities-feedback__short-feedback-text">{{feedback.contentWithTermInterface | translate }}</p>
      }
    </ng-container>
  </div>

  @for (button of buttons; track button) {
    @if (button.display) {
      <button
        class="activities-feedback__action-button"
        [disabled]="button.disable"
        (click)="onAction(button)">
        <span class="activities-feedback__action-label">{{ button.title | translate }}</span>
        @if (button.svgIcon) {
          <mat-icon
            class="activities-feedback__action-icon"
            [svgIcon]="button.svgIcon">
          </mat-icon>
        }
      </button>
    }
  }
</aside>